var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg088Torch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13.83L8 14.54V20C8 20.5523 8.44772 21 9 21H15C15.5523 21 16 20.5523 16 20V14.54L17.05 13.83C18.2682 13.0241 19.0007 11.6606 19 10.2V8C19 7.44772 18.5523 7 18 7H6C5.44772 7 5 7.44772 5 8V10.2C5.01037 11.6702 5.76271 13.0357 7 13.83ZM7 9H17V10.2C17.0125 11.0018 16.617 11.755 15.95 12.2L14.45 13.2C14.1792 13.378 14.0115 13.6762 14 14V19H10V14C9.99827 13.6655 9.82939 13.354 9.55 13.17L8.05 12.17C7.39192 11.7308 6.99767 10.9912 7 10.2V9Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg088Torch);
export default __webpack_public_path__ + "static/media/088-torch.b7758be3dd9faa8ff1d4cd0aba744d9f.svg";
export { ForwardRef as ReactComponent };